module.exports = __webpack_public_path__ + "static/thpcwhiteelephantmummy2-df7eb490dd424af145df1214f0c3eb59.jpeg";